/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuDots8VIcon16Light } from './UiMenuDots8VIcon16Light';
import { UiMenuDots8VIcon16Regular } from './UiMenuDots8VIcon16Regular';
import { UiMenuDots8VIcon16Solid } from './UiMenuDots8VIcon16Solid';
import { UiMenuDots8VIcon20Light } from './UiMenuDots8VIcon20Light';
import { UiMenuDots8VIcon20Regular } from './UiMenuDots8VIcon20Regular';
import { UiMenuDots8VIcon20Solid } from './UiMenuDots8VIcon20Solid';
import { UiMenuDots8VIcon24Regular } from './UiMenuDots8VIcon24Regular';
import { UiMenuDots8VIcon24Solid } from './UiMenuDots8VIcon24Solid';
import { UiMenuDots8VIcon32Regular } from './UiMenuDots8VIcon32Regular';
import { UiMenuDots8VIcon64Regular } from './UiMenuDots8VIcon64Regular';
var sizes = {
    16: {
        light: UiMenuDots8VIcon16Light,
        regular: UiMenuDots8VIcon16Regular,
        solid: UiMenuDots8VIcon16Solid,
    },
    20: {
        light: UiMenuDots8VIcon20Light,
        regular: UiMenuDots8VIcon20Regular,
        solid: UiMenuDots8VIcon20Solid,
    },
    24: {
        regular: UiMenuDots8VIcon24Regular,
        solid: UiMenuDots8VIcon24Solid,
    },
    32: {
        regular: UiMenuDots8VIcon32Regular,
    },
    64: {
        regular: UiMenuDots8VIcon64Regular,
    },
};
export var UiMenuDots8VIcon = forwardRef('UiMenuDots8VIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
